import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import './modalWindow.css'

import { connect } from 'react-redux'
import * as contactActions from '../../../actions/chat/contactActions'

import ModalWindowHeader from './modalWindowHeader/modalWindowHeader'
import ModalWindowBody from './modalWindowBody/modalWindowBody'
import ModalWindowFooter from './modalWindowFooter/modalWindowFooter'

class ModalWindow extends Component {
  EModalWindowState = Object.freeze({
    MAXIMIZED: 0,
    MINIMIZED: 1
  });

  constructor(props) {
    super(props);
    this.windowStateChangeHandler = this.windowStateChangeHandler.bind(this);
    this.windowCloseHandler = this.windowCloseHandler.bind(this);
  }

  state = {
    modalWindowState: this.EModalWindowState.MAXIMIZED,
    modalWindowUnloaded: false,
    modalWindowHidden: false
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.contactModals.length !== this.props.contactModals.length ||
      nextProps.contactWindowState !== this.props.contactWindowState) {
      this.windowOnResizeHandler()
    }
    
    if (nextProps.unreadCount.length > 0) {
      const open = nextProps.unreadCount.filter(uc => uc.contactId === nextProps.contactId).length;
      if (open > 0) {
        this.setState({ modalWindowState: this.EModalWindowState.MAXIMIZED });
      }
    }
  }

  componentDidMount = () => {
    this.subscribeToEvents()
    this.windowOnResizeHandler()
  }

  componentWillUnmount = () => {
    this.unSubscribeToEvents()
  }

  subscribeToEvents = () => {
    window.addEventListener("resize", this.windowOnResizeHandler);
  }

  unSubscribeToEvents = () => {
    window.removeEventListener("resize", this.windowOnResizeHandler);
  }

  windowOnResizeHandler = () => {
    if (typeof this.props.contactModals === 'undefined' || typeof this.props.contactModalsHidden === 'undefined')
      return;

    if (!this.state.modalWindowHidden) {
      var node = ReactDOM.findDOMNode(this)
      if (node) {
        var rect = node.getBoundingClientRect()
        if (rect.x < 50) this.windowHideHandler()
      }
    }
  }

  windowStateChangeHandler = (state) => {
    this.setState({ modalWindowState: state });
  }

  windowCloseHandler = () => {
    this.setState({
      modalWindowUnloaded: true
    })
    setTimeout(() => this.props.contactModalClose(this.props.contactId), 400);
  }

  windowHideHandler = () => {
    if (this.state.modalWindowHidden) return
    this.setState({
      modalWindowHidden: true
    })
    this.props.contactModalHide(this.props.contactId);
  }

  render() {
    const modalWindowState = this.state.modalWindowState;
    const styleUnloaded = this.state.modalWindowUnloaded ? { minWidth: '0px', opacity: 0, marginLeft: '0px' } : {};
    const contact = this.props.contacts.filter(el => { return el.id === this.props.contactId })[0];

    return (
      <div style={styleUnloaded} className="modalWindowContainer">
        <div className={["modalWindow", "shadowBox1", modalWindowState === this.EModalWindowState.MAXIMIZED ?
          "modalWindowMax" : "modalWindowMin", this.props.contactModalBlinkState === this.props.contactId ? "modalWindowBlink" : ""].join(' ')}>
          <ModalWindowHeader
            contactId={contact.id}
            contactName={`${contact.first_name} ${contact.last_name}`}
            modalWindowState={modalWindowState}
            windowStateChangeHandler={this.windowStateChangeHandler}
            windowCloseHandler={this.windowCloseHandler}
            EModalWindowState={this.EModalWindowState}
          />
          {modalWindowState === this.EModalWindowState.MAXIMIZED &&
            [
              <ModalWindowBody key="1" contact={contact} />,
              <ModalWindowFooter key="2" contact={contact} />
            ]
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    contacts: state.user.allUsers,

    contactModalBlinkState: state.contactReducer.contactModalBlink,
    contactWindowState: state.contactReducer.contactWindowState,
    contactModals: state.contactReducer.contactModals,
    contactModalsHidden: state.contactReducer.contactModalsHidden,

    unreadCount: state.messageReducer.unreadCount
  }
}

const mapDispatchToProps = {
  contactModalBlink: contactActions.contactModalBlink,
  contactModalClose: contactActions.contactModalClose,
  contactModalHide: contactActions.contactModalHide
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalWindow);


// WEBPACK FOOTER //
// ./src/common/chat/modalWindow/modalWindow.js